var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBundle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 4.5H2.25C1.83579 4.5 1.5 4.83579 1.5 5.25V21C1.5 21.4142 1.83579 21.75 2.25 21.75H3.75C4.16421 21.75 4.5 21.4142 4.5 21V5.25C4.5 4.83579 4.16421 4.5 3.75 4.5Z",
    stroke: "#A3AED0",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 10.5H11.25M5.25 18.75H11.25",
    stroke: "#A3AED0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.5H6C5.58579 7.5 5.25 7.83579 5.25 8.25V21C5.25 21.4142 5.58579 21.75 6 21.75H10.5C10.9142 21.75 11.25 21.4142 11.25 21V8.25C11.25 7.83579 10.9142 7.5 10.5 7.5Z",
    stroke: "#A3AED0",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 2.25H12.75C12.3358 2.25 12 2.58579 12 3V21C12 21.4142 12.3358 21.75 12.75 21.75H15.75C16.1642 21.75 16.5 21.4142 16.5 21V3C16.5 2.58579 16.1642 2.25 15.75 2.25Z",
    stroke: "#A3AED0",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8028 4.50516L17.9091 4.70438C17.3878 4.75922 17.01 5.24672 17.0686 5.78719L18.7055 20.8617C18.7646 21.4022 19.2385 21.7992 19.7597 21.7448L21.6535 21.5456C22.1747 21.4908 22.5525 21.0033 22.4939 20.4628L20.8594 5.39063C20.798 4.84781 20.3241 4.45031 19.8028 4.50516Z",
    stroke: "#A3AED0",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBundle);
export default __webpack_public_path__ + "static/media/bundle.76782535ee60ee134e75c75f29211ab9.svg";
export { ForwardRef as ReactComponent };